var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuIconVenue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#2D80FC",
    height: "36px",
    width: "36px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 224.089 224.089",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.062,167.072h-73.15c18.527-21.54,55.571-68.165,55.571-96.617c0-38.288-31.149-69.438-69.438-69.438 s-69.438,31.15-69.438,69.438c0,28.452,37.044,75.077,55.572,96.617H25.027L0,223.072h224.089L199.062,167.072z M77.066,82.003 c-2.786-4.722-4.762-9.935-4.435-16.785c0.581-12.126,9.457-22.141,20.326-22.141c11.175,0,19.087,8.9,19.087,8.9 s8.391-8.9,19.086-8.9c10.87,0,19.745,10.014,20.326,22.141c0.328,6.85-1.643,12.042-4.435,16.785 c-5.601,9.515-34.942,28.569-34.942,28.569S82.631,91.437,77.066,82.003z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconVenue);
export default __webpack_public_path__ + "static/media/menu_icon_venue.82f83229a6aedacffe9138b20c5af54e.svg";
export { ForwardRef as ReactComponent };